import "./Navbar.css";
import Logo from "../../images/logo.png";
import {Link} from 'react-router-dom';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import {useState, useRef} from "react";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {ReactComponent as DialPhoneIcon} from "../../dialPhoneIcon.svg";

export default function NavbarMobile() {

    const [isOpen, setIsOpen] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const menu = useRef(null);

    const toggleMenu = () => {
        if (isAnimating) return;

        if (isOpen) {
            setIsAnimating(true);
            menu.current.classList.add('closing');
            setTimeout(() => {
                setIsOpen(false);
                menu.current.classList.remove('closing');
                setIsAnimating(false);
            }, 800)
        }
        else{
            setIsOpen(true);
        }
    };

    return (
        <div id="navbarMobile">
            <div id="navbarMobileLogo">
                <Link to="/">
                    <img id="logo" src={Logo} className="logo" alt="logo"/>
                </Link>
                <div id="contactLinkButtonMobile" className="whatsappButtonMobile">
                    <a href={"https://wa.me/393335731595?text=Salve,%20la%20contatto%20per%20ricevere%20maggiori%20informazioni%20riguardo%20un%20prodotto%20visualizzato%20sul%20vostro%20sito%20web."}>
                        <WhatsAppIcon fontSize="large"/>
                    </a>
                </div>
                <div id="contactLinkButtonMobile" className="telephoneButtonMobile">
                    <a href={"tel:+393335731595"}>
                        <CallIcon fontSize="large"/>
                    </a>
                </div>
                <div id="contactLinkButtonMobile" className="phoneButtonMobile">
                    <a href={"tel:+390803148778"}>
                        <DialPhoneIcon height="29px" width="29px" />
                    </a>
                </div>
                <div id="contactLinkButtonMobile" className="mapsButtonMobile">
                    <a href={"https://www.google.com/maps/dir//Via+Enrico+Toti,+2,+70022+Altamura+BA/@40.8326393,16.4725415,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x13478774533569cf:0xd3c0200ebf623682!2m2!1d16.554933!2d40.832673?hl=it&entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoJLDEwMjExNjQwSAFQAw%3D%3D"}>
                        <LocationOnIcon fontSize="large"/>
                    </a>
                </div>
                <MenuOpenIcon fontSize="large" onClick={toggleMenu}/>
            </div>
            {isOpen && (
                <div id="navbarMobileMenu" ref={menu} className={isOpen ? 'open' : ''} onClick={toggleMenu}>
                    <div id="navbarMobileButtonContainer">
                        <Link id="floatButton" to="/home">HOME</Link>
                        <Link id="floatButton" to="/">CHI SIAMO</Link>
                        <Link id="floatButton" to="/ourmission">LA NOSTRA MISSION</Link>
                        <Link id="floatButton" to="/contactus">CONTATTACI</Link>
                        <Link id="floatButton" to="/workwithus">LAVORA CON NOI</Link>
                    </div>
                    <div id="menuButtonContainer">
                        {/*<Link id="floatButton" to="/filter/grani">*/}
                        {/*    GRANI*/}
                        {/*</Link>*/}
                        <Link id="floatButton" to="/filter/cialde">
                            CIALDE
                        </Link>
                        <Link id="floatButton" to="/filter/capsule_compatibili_nespresso">
                            NESPRESSO
                        </Link>
                        <Link id="floatButton" to="/filter/capsule_compatibili_modo_mio">
                            A MODO MIO
                        </Link>
                        <Link id="floatButton" to="/filter/macchinette">
                            MACCHINETTE
                        </Link>
                        <Link id="floatButton" to="/filter/altri_prodotti">
                            ALTRI PRODOTTI
                        </Link>
                    </div>
                </div>
            )}
        </div>
    )
}